import {useCallback, useState} from 'react';

export const useListingView = () => {
    const [view, setView] = useState<'tile' | 'list'>('tile');
    const handleChangeView = useCallback((value: 'tile' | 'list') => {
        setView(value);
    }, []);

    return {
        view,
        handleChangeView,
    };
};
